import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

export const checkIsProduction = () => {
  return import.meta.env.VITE_NODE_ENV === "production";
};

export const initDatadog = () => {
  datadogRum.init({
    applicationId: "ad0b7b23-eb1b-423d-a652-881790c9dac1",
    clientToken: "pubbe5f3449616e747208253569cfcc08a5",
    site: "datadoghq.com",
    env: import.meta.env.VITE_NODE_ENV,
    service: "mash-start-tool",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [import.meta.env.VITE_BASE_API_URL as string],
  });

  datadogLogs.init({
    clientToken: "puba69f4a9559b88ee78d41d598f50cd5aa",
    site: "datadoghq.com",
    env: import.meta.env.VITE_NODE_ENV,
    service: "mash-start-tool",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  datadogRum.startSessionReplayRecording();
};
